import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import { connect } from 'react-redux';
import ProjectForm from '../../../containers/ProjectForm';
import {
  setActiveProjectSection,
  SINGLE_PROJECT_BASIC_SECTION,
  updateActiveProject
} from '../data/projectActions';

class BasicInformation extends Component {
  constructor(props) {
    super(props);

    this.updateProject = this.updateProject.bind(this);
  }

  componentDidMount() {
    this.props.dispatch(setActiveProjectSection(SINGLE_PROJECT_BASIC_SECTION));
  }

  /**
   * Updates the project to the API
   * @param project
   */
  updateProject(project) {
    const callback = () => {
      this.props.history.push('/projects');
    };

    this.props.dispatch(updateActiveProject(project, callback));
  }

  render() {
    const projectUnlocked = this.props.project && this.props.project.template_locked === 1;

    const disabledAttributes = {
      start_date: projectUnlocked,
      end_date: projectUnlocked,
      total_participants: projectUnlocked
    };

    return (
      <Grid.Row>
        <Grid.Column>
          <ProjectForm
            initialValues={this.props.project}
            disabledAttributes={disabledAttributes}
            onSubmit={this.updateProject}
          />
        </Grid.Column>
      </Grid.Row>
    );
  }
}

export default connect(state => ({
  project: state.projects.single.active
}))(BasicInformation);



// WEBPACK FOOTER //
// ./src/scenes/projects/scenes/singleProject/containers/BasicInformation.js